import request from '@/utils/request'
import host from '@/api/base/host'
import { AsyncRequest } from '@/utils/request'
const apiUrl = host.path('dev', { module: 'receivePage', dev: 'v1' })

export function getDetail(data) {
  return AsyncRequest({
    loading: true,
    request: () =>
      request({
        url: apiUrl('/order/dw/list'),
        method: 'post',
        data
      })
  })
}
export function updateAddress(data) {
  return AsyncRequest({
    loading: true,
    request: () =>
      request({
        url: apiUrl('/order/dw/address/update'),
        method: 'post',
        data
      })
  })
}
